var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgVe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7303_39027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8093 17.2174C23.5722 15.6397 24 13.8699 24 12C24 10.1301 23.5722 8.36025 22.8093 6.78262L12 5.73914L1.19072 6.78262C0.427828 8.36025 0 10.1301 0 12C0 13.8699 0.427828 15.6397 1.19072 17.2174L12 18.2609L22.8093 17.2174Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24C16.7574 24 20.8682 21.2313 22.8092 17.2174H1.19067C3.13167 21.2313 7.24242 24 12 24Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7829 14.3556L20.1491 14.8508L20.4241 15.6065L19.7572 15.1568L19.1234 15.652L19.345 14.8788L18.6782 14.429L19.4821 14.401L19.7039 13.6278L19.9791 14.3836L20.7829 14.3556Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1598 11.5445L18.7336 12.2266L19.2507 12.8427L18.4702 12.6483L18.0439 13.3303L17.9877 12.5279L17.2073 12.3333L17.9531 12.0319L17.8971 11.2295L18.4141 11.8458L19.1598 11.5445Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6731 9.45792L16.506 10.2447L17.2025 10.6469L16.4026 10.7312L16.2354 11.5178L15.9082 10.7831L15.1082 10.867L15.706 10.3288L15.3789 9.59409L16.0754 9.99618L16.6731 9.45792Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6231 8.34782L13.7352 9.14437L14.5272 9.28396L13.8043 9.63675L13.9163 10.4332L13.3575 9.85462L12.6344 10.2072L13.0122 9.49692L12.4534 8.91839L13.2456 9.05803L13.6231 8.34782Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3772 8.34782L10.7549 9.05803L11.5469 8.91829L10.9883 9.49706L11.3658 10.2073L10.6429 9.85462L10.084 10.4331L10.1961 9.63675L9.47314 9.28415L10.2653 9.14437L10.3772 8.34782Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.32687 9.45792L7.92472 9.99618L8.62114 9.59409L8.29409 10.3291L8.89179 10.8672L8.09187 10.7831L7.76459 11.5178L7.59758 10.7311L6.79761 10.6471L7.49417 10.2448L7.32687 9.45792Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.84022 11.5445L5.58614 11.8458L6.10298 11.2296L6.04706 12.0322L6.79275 12.3336L6.01232 12.528L5.95612 13.3303L5.53003 12.6483L4.74951 12.8428L5.26654 12.2266L4.84022 11.5445Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.21729 14.3556L4.02129 14.3836L4.29625 13.6279L4.51821 14.4011L5.32197 14.4292L4.65513 14.879L4.87675 15.6522L4.243 15.157L3.57611 15.6066L3.85122 14.8508L3.21729 14.3556Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8092 6.78262C20.8682 2.76867 16.7574 0 12 0C7.24242 0 3.13167 2.76867 1.19067 6.78262H22.8092Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7303_39027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVe);
export default __webpack_public_path__ + "static/media/ve.4a8c89923d3d3a1fe2319ebb5bff0e37.svg";
export { ForwardRef as ReactComponent };